import React from "react";

export default function SvgComponent() {
  return (
    <svg viewBox="0 0 145 145" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h145v145H0z" fill="#d98a90" />
      <path
        d="M109.374 115.394c-4.964-9.396-36.874-15.292-36.874-15.292s-31.911 5.896-36.875 15.292C31.957 128.433 28.888 145 28.888 145h87.223c.001 0-2.07-17.764-6.737-29.606z"
        fill="#f1c9a5"
      />
      <path
        d="M72.501 100.102s31.91 5.896 36.874 15.292c4.666 11.842 6.737 29.606 6.737 29.606H72.501v-44.898z"
        fill="#e4b692"
      />
      <path d="M63.814 81.001h17.374v29.077H63.814z" fill="#f1c9a5" />
      <path d="M72.501 81.001h8.688v29.077h-8.688z" fill="#e4b692" />
      <path
        d="M63.814 94.474c1.563 4.485 7.867 7.057 12.498 7.057a15.61 15.61 0 004.876-.795V81.001H63.814v13.473z"
        fill="#ddac8c"
        opacity=".1"
      />
      <path
        d="M109.374 115.394c-2.898-5.487-14.979-9.777-24.534-12.399-.374 6.499-5.746 11.658-12.34 11.658-6.593 0-11.965-5.159-12.339-11.658-9.557 2.622-21.636 6.912-24.536 12.399C31.957 128.433 28.888 145 28.888 145h87.223c.001 0-2.07-17.764-6.737-29.606z"
        fill="#fff"
      />
      <path
        d="M94.837 62.652c0-18.162-10.001-28.489-22.337-28.489-12.337 0-22.338 10.327-22.338 28.489 0 7.609 2.329 24.456 6.301 27.889 2.73 2.424 11.637 6.576 15.991 6.576h.002l.046-.002.043.002h.002c4.357 0 13.264-4.152 15.991-6.576 4.131-4.363 6.299-20.905 6.299-27.889z"
        fill="#f1c9a5"
      />
      <path
        d="M72.503 97.116l.043.002h.002c4.357 0 13.264-4.152 15.991-6.576 4.13-4.364 6.299-20.905 6.299-27.889 0-18.162-10.001-28.489-22.337-28.489v62.952h.002z"
        fill="#e4b692"
      />
      <path
        d="M91.439 75.247c-4.049-.424-6.783-4.787-6.098-9.739.677-4.957 4.513-8.638 8.563-8.216 4.047.422 6.777 4.783 6.094 9.739-.679 4.957-4.51 8.634-8.559 8.216z"
        fill="#e4b692"
      />
      <path
        d="M45.162 67.031c-.684-4.957 2.047-9.317 6.092-9.739 4.053-.422 7.888 3.259 8.567 8.216.684 4.953-2.053 9.315-6.1 9.739-4.049.418-7.88-3.259-8.559-8.216z"
        fill="#f1c9a5"
      />
      <path
        d="M43.649 145h57.703v-36.042c-4.9-2.464-11.108-4.48-16.511-5.962-.374 6.499-5.746 11.658-12.34 11.658-6.593 0-11.965-5.159-12.339-11.658-5.403 1.482-11.612 3.499-16.513 5.964V145z"
        fill="#e00315"
      />
      <path
        d="M72.501 116.411c7.587 0 13.917-5.387 15.373-12.545-1.56-.464-3.091-.894-4.541-1.277-.532 5.516-5.178 9.828-10.832 9.828-5.655 0-10.301-4.312-10.833-9.828-1.45.383-2.981.813-4.541 1.277 1.456 7.158 7.786 12.545 15.374 12.545z"
        fill="#fff"
      />
      <g fill="#262421">
        <path d="M50.541 46.682c-2.182 4.591-1.903 11.531-1.903 11.531s2.661.734 3.569 4.067c0-8.026 1.091-17.088 7.725-17.718 5.981-.567 5.526 2.044 12.569 2.044V31.797s-14.888 0-21.96 14.885z" />
        <path d="M94.46 46.682c-6.266-14.885-21.959-14.885-21.959-14.885v14.809c7.042 0 6.587-2.611 12.568-2.044 6.634.63 7.723 9.692 7.723 17.718.91-3.333 3.559-4.158 3.559-4.158s.08-6.756-1.891-11.44z" />
      </g>
      <g fill="#262421">
        <path d="M72.503 81.001v2.739l-7.712 1.292v-1.027z" />
        <path d="M72.501 81.001v2.739l7.711 1.292v-1.027z" />
      </g>
      <g fill="#3c1e1c">
        <path d="M55.19 136.889L49.42 145l-5.771-8.111 5.771-8.111 5.77 8.111z" />
        <path d="M66.73 136.889L60.959 145l-5.77-8.111 5.77-8.111 5.771 8.111zM78.27 136.889L72.501 145l-5.771-8.111 5.771-8.111 5.769 8.111z" />
        <path d="M89.811 136.889L84.041 145l-5.771-8.111 5.771-8.111 5.77 8.111zM101.351 136.889L95.581 145l-5.77-8.111 5.77-8.111 5.77 8.111z" />
        <g>
          <path d="M55.19 110.078l-5.77 8.11-5.771-8.11 5.771-8.111 5.77 8.111z" />
          <path d="M66.73 110.078l-5.771 8.11-5.77-8.11 5.77-8.111 5.771 8.111z" />
          <path d="M78.27 110.078l-5.769 8.11-5.771-8.11 5.771-8.111 5.769 8.111zM89.811 110.078l-5.77 8.11-5.771-8.11 5.771-8.111 5.77 8.111zM101.351 110.078l-5.77 8.11-5.77-8.11 5.77-8.111 5.77 8.111z" />
        </g>
        <g>
          <path d="M60.959 123.997l-5.77 8.111-5.77-8.111 5.77-8.111 5.77 8.111zM72.501 123.997l-5.771 8.111-5.771-8.111 5.771-8.111 5.771 8.111z" />
          <path d="M84.041 123.997l-5.771 8.111-5.769-8.111 5.769-8.111 5.771 8.111zM95.581 123.997l-5.77 8.111-5.77-8.111 5.77-8.111 5.77 8.111zM95.581 123.997l5.77 8.111v-16.222zM49.42 123.997l-5.771-8.111v16.222z" />
        </g>
      </g>
    </svg>
  );
}
